import React, { useContext } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import UserListItemTile from 'src/components/User/ListItemTile'
import { useOrganization, useUserList } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const GroupPeople = () => {
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()

   // TODO: This is temporary until there are real theme props
   // See PR #631
   const isMotherCo = organization.slug === 'mother-co'

   const { initiative } = useContext(InitiativeHierarchyContext)
   const { userList } = useUserList({
      userRelationshipFilter: {
         entityType: 'initiative',
         entityId: initiative.id,
         hasRoleParticipantElement: {
            roleType: 'primary',
            status: 'active'
         }
      },
      withRelationship: true,
      withRelationshipEntityType: 'initiative',
      withRelationshipEntityId: initiative.id
   })

   return (
      <View width="100%">
         <View
            display="flex"
            alignItems="center"
            width="100%"
            height="60px[a-d] 80px[e-f]"
            marginBottom="20px"
            backgroundColor={theme.tmpContentBackgroundColor}
            borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
            <Text
               color={theme.tmpContentTitleColor}
               size="6"
               {...(isMotherCo && {
                  transform: 'uppercase',
                  letterSpacing: '1px',
                  weight: 'bold',
                  size: '2[a-d] 2.5[e-f]'
               })}>
               Members
            </Text>
         </View>
         {userList.items.length === 0 && (
            <View textAlign="center" padding="20px">
               <Text size="1.5">
                  {`No one in this ${initiative.type.nameSingular} to show yet`}
               </Text>
            </View>
         )}
         <View
            borderTop="1px solid rgba(255,255,255,0.15)"
            margin="10px 0px">
            <Grid columns="1[a] 2[b-d] 3[e-f]">
               {userList.items.map(user => (
                  <GridCell key={user.id}>
                     <UserListItemTile
                        id={user.id}
                        avatarMedia={user.avatarMedia}
                        fullName={user.fullName}
                        organization={user.organization}
                        position={user.position}
                     />
                  </GridCell>
               ))}
            </Grid>
         </View>
      </View>
   )
}

export default GroupPeople
